import { useState, useMemo, useEffect } from 'react';
import type { question } from '@/features/simulationConfiguration/types.api';

export const useQuestionManager = (questions: question[]) => {
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

    useEffect(() => {
        setCurrentQuestionIndex(0);
    }, [questions]);

    const currentQuestion = useMemo(() => {
        return questions[currentQuestionIndex] || null;
    }, [questions, currentQuestionIndex]);

    const totalQuestions = questions.length;

    const goToQuestion = (index: number) => {
        if (index >= 0 && index < totalQuestions) {
            setCurrentQuestionIndex(index);
        }
    };

    const goToNext = () => goToQuestion(currentQuestionIndex + 1);
    const goToPrevious = () => goToQuestion(currentQuestionIndex - 1);

    return {
        currentQuestion,
        currentQuestionIndex,
        totalQuestions,
        goToQuestion,
        goToNext,
        goToPrevious,
    };
};
